import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-product-setting-mc',
  templateUrl: './product-setting-mc.component.html',
  styleUrls: ['./product-setting-mc.component.css']
})
export class ProductSettingMcComponent implements OnInit {
    productSettingKeyno;

    public productSettingMcKeyno: string;

    public edit?: Edit;

    public selectListMetaColumns: MetaColumnItem[] = [];

    public productSettingMcItems: Item[] = [];

    //public productSettingMcItemsDefault: DefaultItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.productSettingKeyno = this.stateService.getStateParams()['productsetting_keyno'];
        this.productSettingMcKeyno = this.stateService.getStateParams()['productsettingmc_keyno'];
    }

    private async loadEdit() {
        if (!!this.productSettingKeyno && !!this.productSettingMcKeyno) {
            this.edit = (await this.datatask.Post(3060, {
                productsetting_keyno: this.productSettingKeyno,
                productsettingmc_keyno: this.productSettingMcKeyno
            }))[0];
        }
    }

    private async loadMetaColumns(): Promise<void> {
        if (!!this.edit?.productsetting_keyno) {
            this.selectListMetaColumns = await this.datatask.Post(3062, { productsetting_keyno: this.edit.productsetting_keyno });
        }
    }

    private async loadProductSettingMcItems(): Promise<void> {
        if (!!this.edit?.productsettingmc_keyno) {
            this.productSettingMcItems = await this.datatask.Post(3561, { productsettingmc_keyno: this.edit.productsettingmc_keyno });

            //this.productSettingMcItemsDefault = [{
            //    productsettingmcitem_keyno: 0,
            //    productsettingmcitem_name: '',
            //    item_id: 0,
            //    item_name: '',
            //    orderby: 0
            //}];

            //this.productSettingMcItemsDefault.push(...this.productSettingMcItems);
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3063, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(3064, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'productsettingmcitem':
                this.stateService?.go('productsettingmcitem', {
                    productsettingmc_keyno: this.edit?.productsettingmc_keyno,
                    productsettingmcitem_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadMetaColumns();
        this.loadProductSettingMcItems();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    productsettingmc_keyno: number;
    productsetting_keyno: number;
    metacolumn_keyno: number;
    default_value: string;
    prefix_value: string;
    orderby: number;
    productsetting_name: string;
    colname: string;
    build_product_name: number;
    requiredfield: number;
    protected: number;
    build_prod_id: number;
    prod_id_length: number;
    prod_id_prefix: string;
    prod_id_postfix: string;
    elementtype: string;
    lastnumber: number;
}

interface MetaColumnItem {
    metacolumn_keyno: number;
    item_name: string;
    elementtype: string;
    orderby: number;
}

//interface DefaultItem {
//    productsettingmcitem_keyno: number;
//    productsettingmcitem_name: string;
//    item_id: number;
//    item_name: string;
//    orderby: number;
//}





//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productSettingMc', {
//        templateUrl: 'views/components/views/productSettingMc/productSettingMc.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'productSettingMcService', function ($stateParams, stateService, utilityService, modalService, translateService, productSettingMcService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let productSettingKeyno = $stateParams.productsetting_keyno;
//            let productSettingMcKeyno = $stateParams.productsettingmc_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                productSettingMcKeyno: productSettingMcKeyno,
//                edit: {},
//                selectListMetaColumns: [],
//                productSettingMcItems: [],
//                productSettingMcItemsDefault: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await productSettingMcService.getEdit({
//                    productsetting_keyno: productSettingKeyno,
//                    productsettingmc_keyno: productSettingMcKeyno
//                }))[0];

//                return Promise.all([
//                    loadMetaColumns(),
//                    loadProductSettingMcItems()
//                ]).then(() => Promise.resolve());

//                return Promise;
//            }

//            async function loadMetaColumns() {
//                if (utilityService.validateParmsValue(vm.model.edit.productsetting_keyno) !== true) return;

//                return vm.model.selectListMetaColumns = await productSettingMcService.listMetaColumns({ productsetting_keyno: vm.model.edit.productsetting_keyno });
//            }

//            async function loadProductSettingMcItems() {
//                return vm.model.productSettingMcItems = await productSettingMcService.listProductSettingMcItems({ productsettingmc_keyno: vm.model.edit.productsettingmc_keyno });

//                vm.model.productSettingMcItemsDefault = [{
//                    productsettingmcitem_keyno: 0,
//                    productsettingmcitem_name: '',
//                    item_id: 0,
//                    item_name: '',
//                    orderby: 0
//                }];

//                vm.model.productSettingMcItemsDefault.push(...vm.model.productSettingMcItems);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            vm.onChange = function (key, value) {
//                vm.model.edit[key] = value;

//                if (key === 'metacolumn_keyno') {
//                    vm.model.edit.elementtype = vm.model.selectListMetaColumns.find(e => e.metacolumn_keyno === value)?.elementtype;
//                }
//            }

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                productSettingMcService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    productSettingMcService.deleteItem(vm.model.edit).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
